import { AdZone } from "models/Ads";
import { GenericService, Service } from "./genericService";
import axios from "axios";

class AdsService extends GenericService<AdZone> implements Service<AdZone> {
    constructor() {
        super("api/ads");
    }

    getAdsByZones = async (zones: string[]): Promise<AdZone[]> => {
        const res = await axios.get(`${this.baseUrl}`, {
            params: { zones: zones.join(',') }
        });

        return res.data;
    }
}

export default new AdsService();
